// Format date to "Idag, Igår or 2024-09-25"
export const formatRelative = (
  _date: string,
  locale?: string,
  timeZone?: string
) => {
  const date = new Date(_date);
  const today = new Date();
  const yesterday = new Date();

  yesterday.setDate(today.getDate() - 1);

  if (date.toDateString() === today.toDateString()) {
    return "Idag";
  }

  if (date.toDateString() === yesterday.toDateString()) {
    return "Igår";
  }

  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone,
  }).format(date);
};

// Format date to "12:33"
export const formatTime = (
  _date: string | number | Date,
  locale?: string,
  timeZone?: string
) => {
  const date = new Date(_date);

  return new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
    timeZone,
  }).format(date);
};

// Format date to "9 sept."
export const formatMonthDay = (
  _date: string,
  locale?: string,
  timeZone?: string
) => {
  const date = new Date(_date);

  return new Intl.DateTimeFormat(locale, {
    month: "short",
    day: "numeric",
    timeZone,
  }).format(date);
};

// Format date to "6 augusti 2024, 14:00"
export const formatDate = (
  _date: string,
  locale?: string,
  timeZone?: string
) => {
  const date = new Date(_date);

  const formattedDate = new Date(date).toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone,
  });

  const timeParts = new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone,
  }).formatToParts(date);

  const formattedTime = timeParts.map((part) => part.value).join("");

  return `${formattedDate}, ${formattedTime}`;
};

export const localDate = (_date?: string | number | Date) => {
  return new Date(
    new Date(_date ? _date : Date.now()).toLocaleString("sv-SE", {
      timeZone: "Europe/Stockholm",
    })
  );
};
